/**
 * 自动配菜页表单持久化，从菜谱跳转生成时仍能按人数/餐标算汇总
 */
const STORAGE_KEY = 'foodtoge_generate_form'

export function loadGenerateForm() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return {
      orderDate: parsed.orderDate || '',
      roomName: parsed.roomName || '',
      guestCount: parsed.guestCount || '',
      perCapita: parsed.perCapita || '',
      profitRatePercent: parsed.profitRatePercent || '',
      needWei: parsed.needWei === true
    }
  } catch (e) {
    return null
  }
}

export function saveGenerateForm(form) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      orderDate: form.orderDate || '',
      roomName: form.roomName || '',
      guestCount: form.guestCount || '',
      perCapita: form.perCapita || '',
      profitRatePercent: form.profitRatePercent || '',
      needWei: form.needWei === true
    }))
  } catch (e) {
    // ignore
  }
}
